import {type AppEnvironment} from '@models/environment';

// This is the environment file for running the frontend in the local dev environment.
// See `angular.json` for more details.

export const environment: AppEnvironment = {
  api: `http://localhost:5000`,
  envName: 'local',
  hostname: 'localhost',
  instanceName: 'Local',
  seoBotsMeta: 'noindex, nofollow',
  userMode: 'dev',
  bypassPrerenderApi: true,
};
